import React from 'react'
import { RouteHandler, Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import { config } from 'config'
import './style.css'
import '../../static/fonts/fontawesome/style.css'

class SiteLinks extends React.Component {
    render() {

        return (
            <div className='social'>
              <a className="social-item sleek-button" id="email" href={ config.siteEmailUrl }>
                <i className='fa fa-envelope-o logo'></i><span className="name">Email</span><i className="fa fa-external-link" aria-hidden="true"></i>
              </a>
              <a className="social-item sleek-button" id="twitter" href={ config.siteTwitterUrl }>
                <i className='fa fa-twitter logo'></i><span className="name">Twitter</span><i className="fa fa-external-link" aria-hidden="true"></i>
              </a>
              <a className="social-item sleek-button" id="github" href={ config.siteGithubUrl }>
                <i className='fa fa-github-alt logo'></i><span className="name">GitHub</span><i className="fa fa-external-link" aria-hidden="true"></i>
              </a>
              <a className="social-item sleek-button" id="instagram" href={ config.siteInstagramUrl }>
                <i className='fa fa-instagram logo'></i><span className="name">Instagram</span><i className="fa fa-external-link" aria-hidden="true"></i>
              </a>
              <a className="social-item sleek-button" id="linkedin" href={ config.siteLinkedinUrl }>
                <i className='fa fa-linkedin logo'></i><span className="name">LinkedIn</span><i className="fa fa-external-link" aria-hidden="true"></i>
              </a>
            </div>
            );
    }
}

export default SiteLinks



// WEBPACK FOOTER //
// ../components/SiteLinks/index.jsx